import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userInfoWrapper: {
    ...theme.mixins.appContainer,
    display: 'flex',
    gap: 8,
    marginBottom: 8,
  },
  avatar: {},
  userDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  info: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  description: {
    color: theme.palette.text.secondary,
  },
  stats: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    margin: `${theme.spacing(1)} 0`,
    color: theme.palette.text.secondary,
    flexWrap: 'wrap',
  },
  statsValue: {
    color: theme.palette.text.primary,
    fontWeight: 700,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: 8,
  },
  noAccessContainer: {
    ...theme.mixins.appContainer,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  noAccessIcon: {
    width: 64,
    height: 64,
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('sm')]: {
      width: 56,
      height: 56,
    },
  },
  noAccessText: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  lockedProfileInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  lockedProfileIcon: {
    width: 18,
    height: 18,
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
  privatePostsContainer: {
    ...theme.mixins.appContainer,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  privatePostsIconWrapper: {
    width: 132,
    height: 132,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'hsl(220 15% 20%)'
        : theme.palette.background.default,
    [theme.breakpoints.down('sm')]: {
      width: 108,
      height: 108,
    },
  },
  privatePostsIcon: {
    width: 96,
    height: 96,
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('sm')]: {
      width: 80,
      height: 80,
    },
  },
  privatePostsTitle: {
    fontWeight: 600,
  },
  privatePostsDescription: {
    maxWidth: 480,
    color: theme.palette.text.secondary,
  },
  userDetailsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  userPostsWrapper: {
    flex: 2,
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  userRelationsWrapper: {
    width: '100% !important',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    flex: 1,
  },
  userRelationsContainer: {
    ...theme.mixins.appContainer,
  },
  userRelationsHeader: {
    display: 'flex',
    gap: 8,
    color: theme.palette.text.primary,
    textDecoration: 'unset',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  userRelationsTitle: {
    ...theme.mixins.appEllipsis,
    fontWeight: 600,
    margin: '8px 0 8px 8px',
    fontSize: 14,
  },
  userRelationsCounter: {
    fontWeight: 600,
    marginLeft: theme.spacing(0.5),
    color: theme.palette.grey[600],
  },
}));
